import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateApiKeyRequest } from '../types';
import { ApiKeysService } from '../services';

/**
 * Hook para criar uma nova API Key
 *
 * IMPORTANTE: A key completa só é retornada uma vez após a criação.
 * Certifique-se de exibir a key para o usuário copiar antes de fechar o modal.
 *
 * @example
 * const { mutate: createKey, isPending, isSuccess, data } = useCreateApiKey();
 *
 * const handleCreate = () => {
 *   createKey({ name: 'Minha API Key', permissions: ['leads:create'] });
 * };
 */
export const useCreateApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateApiKeyRequest) => ApiKeysService.createApiKey(data),
    onSuccess: () => {
      // Invalida lista de API keys para forçar refresh
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
};
